import { Component, inject, input } from '@angular/core';
import { SuperSectionVM } from '../../../../models/menu.model';
import { ThemeService } from '../../../../services/theme.service';

// Shared grid/slider rendering of super-section links (image + name) - used
// both for the menu-home grid layout and for cross-section search suggestions elsewhere.
@Component({
  selector: 'app-super-section-scroll',
  templateUrl: './super-section-scroll.component.html',
  styleUrl: './super-section-scroll.component.scss',
  standalone: false,
})
export class SuperSectionScrollComponent {
  sections = input.required<SuperSectionVM[]>();
  // 'grid': fixed 3-per-row layout. 'slider': horizontal scroll, fixed item width.
  mode = input<'grid' | 'slider'>('grid');

  readonly placeholderImage = inject(ThemeService).placeholderImage;
}
